export default {
    computed: {
        boxClass() {
            if (this.theme == 'bs3') {
                return {
                    box: 'panel panel-default',
                    boxHeader: 'panel-heading',
                    boxBody: 'panel-body',
                    boxFooter: 'panel-footer',
                    padding: ''
                }
            } else if (this.theme == 'evt') {
                return {
                    box: 'box box-default',
                    boxHeader: 'box-header with-border',
                    boxBody: 'box-body',
                    boxFooter: 'box-footer',
                    padding: ''
                }
            } else {
                return {
                    box: 'card card-default',
                    boxHeader: 'card-header',
                    boxBody: 'card-body',
                    boxFooter: 'card-footer',
                    padding: 'px-0 py-0'
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/Assets/components/Participants/Form/mixins/boxClassMixin.js